// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2b3xp","large":"styles_large__1NuWP"};